
const sidebarToggleState = localStorage.getItem("sidebarToggleState")
const state = {
  toggleState: [undefined, null].includes(sidebarToggleState) ? true : JSON.parse(sidebarToggleState),
  openMenu: false
}

const getters = {
  getToggleState: (state) => {
    return state.toggleState
  },
  getOpenMenu: (state) => {
    return state.openMenu
  },
}

const mutations = {
  setToggleState: (state, payload) => {
    state.toggleState = payload
    localStorage.setItem("sidebarToggleState", payload)
  },
  setOpenMenu: (state, payload) => {
    state.openMenu = payload
  },
}

const actions = {
  actionSetToggleState: ({commit}, payload) => {
    commit("setToggleState", payload)
  },
  actionSetOpenMenu: ({commit}, payload) => {
    commit("setOpenMenu", payload)
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
